var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "../base";
import { Icon } from "./icon";
var FloatingIcon = /** @class */ (function (_super) {
    __extends(FloatingIcon, _super);
    function FloatingIcon(configuration, onClickAction) {
        var _this = _super.call(this) || this;
        _this.addDisplayStyle = function (div) {
            div.insertAdjacentHTML('afterbegin', "\n            <style type=\"text/css\">\n                #js_aigo_bot_chat_button {\n                    display: inline-flex;\n                }\n            </style>\n        ");
        };
        var button = document.createElement('div');
        button.id = 'js_aigo_bot_chat_button';
        button.style.float = 'right';
        button.style.marginTop = '18px';
        var source = configuration.floatingIconChatActiveClosingIcon;
        if (!source || source.length === 0) {
            source = process.env.AIGO_FLOATING_ICON_CHAT_ACTIVE_DEFAULT_CLOSING_ICON;
        }
        _this._closeIcon = new Icon('js_aigo_bot_floating_close_icon', configuration.floatingIconChatActiveClosingIcon, '58px', '58px', null, null, onClickAction, true, 'Close chat');
        button.appendChild(_this._closeIcon.self);
        _this.addDisplayStyle(button);
        _this.self = button;
        return _this;
    }
    return FloatingIcon;
}(Base));
export { FloatingIcon };
